import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=c5ed9ff8&scoped=true"
import script from "./journal.vue?vue&type=script&lang=js"
export * from "./journal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ed9ff8",
  null
  
)

export default component.exports